<template>
  <div class="ui-layout-center footer">
    {{$t('footer.copyRight')}}
    <router-link to="/components/version" class="ui-text-decoration--none">
      <span class="ui-foot-link ui-font--small">{{$t('footer.versionUpdate')}}</span>
    </router-link>
  </div>
</template>

<script>
export default {
    name: 'FooterBar',
};
</script>

<style lang="less" scoped>
.footer{
    color: #898989;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    background-color: #fff;
    text-align: center;
}
</style>
